var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { staticClass: "mb" },
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "3" } },
        [
          _c("app-label", {
            attrs: {
              decimals: _vm.decimals,
              label: _vm.$ct("labels.unitPrice"),
              value: _vm.pricePerUnit,
            },
          }),
        ],
        1
      ),
      _vm.showPurchaseDetails
        ? _c(
            "w-col",
            { attrs: { xs: "6", md: "2" } },
            [
              _c("app-label", {
                attrs: {
                  decimals: _vm.decimals,
                  label: _vm.$ct("labels.profit"),
                  value: _vm.computedValues.profit,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showPurchaseDetails
        ? _c(
            "w-col",
            { attrs: { xs: "6", md: "2" } },
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.profitPercent"),
                  value: _vm.computedValues.profitPercentage,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-col",
        { attrs: { xs: "6", md: "2" } },
        [
          _c("app-label", {
            attrs: {
              value: `${_vm.currentPercentage}%`,
              label: _vm.$ct("labels.vat"),
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "6", md: "3" } },
        [
          _c("app-label", {
            attrs: {
              decimals: _vm.decimals,
              label: _vm.$ct("labels.brutoPrice"),
              value: _vm.computedValues.bruto,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }